"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TruncatedText = TruncatedText;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
const tooltip_1 = require("./tooltip");
function textOf(node) {
    if (typeof node === 'string')
        return node;
    if (typeof node === 'number')
        return String(node);
    return null;
}
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ TEXT THAT MAY BE CUT OFF, AND SAYS SO ONLY WHEN IT IS.               │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * What replaced the kit's `title={label}` on every ellipsed name (20 Oct 2026 — no native tooltips,
 * anywhere). A native title showed on every hover, truncated or not, so a short name repeated
 * itself in a grey box under the pointer; this shows the kit's tooltip, and only when
 * `scrollWidth > clientWidth` at the moment of hover.
 *
 * ⚠️ **The span IS the truncating element — there is no wrapper.** `block min-w-0 max-w-full
 * truncate`, so the ellipsis works as a flex item (where a flex child's `min-width: auto` would
 * otherwise refuse to shrink) and as a block. Pass `flex-1` and the like through `className`.
 *
 * ⚠️ **Nothing is measured at rest.** A list of hundreds of rows pays for one boolean each; the
 * measurement happens on hover or focus, and the surface mounts only then.
 */
function TruncatedText({ children, tooltip, className }) {
    const explicit = tooltip !== undefined && tooltip !== null && tooltip !== '' && tooltip !== textOf(children);
    const tip = (0, tooltip_1.useTooltip)(tooltip === undefined || tooltip === null || tooltip === '' ? children : tooltip, explicit ? {} : { when: tooltip_1.isTruncated });
    return ((0, jsx_runtime_1.jsxs)("span", { className: (0, cn_1.cn)('block max-w-full min-w-0 truncate', className), ...tip.triggerProps({}), children: [children, tip.bubble] }));
}
//# sourceMappingURL=truncated-text.js.map